import { dataCollectionStore } from "../stores/dataCollectionOverview.store";
import { onboardStore } from "../stores/onboard.store";

export const useOnboardStore = () => onboardStore;

export const useDataCollectionOverveiwStore = () => dataCollectionStore;
